import React, { useEffect, useState } from "react";
import styles from "./student-details.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { CheckCircleOutlined, LeftOutlined } from "@ant-design/icons";
import { Popconfirm, Tabs, Typography } from "antd";
import CustomButton from "../../../../common/custom-button/custom-button";
import StatusChip from "../../../../components/status-chip/status-chip";
import Details from "./components/details/details";
import Attendance from "./components/attendance/attendance";
import Bursary from "./components/bursary/bursary";
import NonAcademicActivity from "./components/non-academic-activity/non-academic-activity";
import Payment from "./components/payment/payment";
import Communication from "./components/communication/communication";
import ParentDetails from "./components/parent-details/parent-details";
import {
  fetchStudentDetails,
  suspendStudent,
} from "../../../../services/student";
import { toast } from "react-toastify";
import StudentReportCard from "./components/student-report-card/student-report-card";

const StudentDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [studentDetails, setStudentDetails] = useState(null);
  const [triggerRefetch, setTriggerRefetch] = useState(0);

  const searchParams = new URLSearchParams(location.search);
  const studentID = searchParams.get("id") || "";

  const items = [
    {
      key: "1",
      label: "Details",
      children: <Details details={studentDetails} />,
    },
    {
      key: "2",
      label: "Attendance",
      children: (
        <Attendance
          studentID={studentDetails?.id}
          classroomID={studentDetails?.classroom_id}
        />
      ),
    },
    {
      key: "3",
      label: "Payment",
      children: <Payment studentID={studentDetails?.id} />,
    },
    {
      key: "4",
      label: "Parent Details",
      children: (
        <ParentDetails
          details={studentDetails}
          setTriggerRefetch={setTriggerRefetch}
        />
      ),
    },
    {
      key: "5",
      label: "Communication",
      children: <Communication studentID={studentDetails?.id} />,
    },
    {
      key: "6",
      label: "Bursary",
      children: <Bursary studentID={studentDetails?.id} />,
    },
    {
      key: "7",
      label: "Non Academic Activity",
      children: <NonAcademicActivity studentID={studentDetails?.id} />,
    },
    {
      key: "8",
      label: "Report Card",
      children: <StudentReportCard studentID={studentDetails?.id} />,
    },
  ];

  useEffect(() => {
    studentID && getStudentDetails();
  }, [studentID, triggerRefetch]);

  const getStudentDetails = async () => {
    try {
      setLoading(true);
      const response = await fetchStudentDetails(studentID);
      if (response?.data) {
        setStudentDetails(response?.data?.data);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };

  const onSuspendAccount = async (isSuspend) => {
    try {
      const payload = {
        id: studentID,
        suspend: isSuspend,
      };
      const response = await suspendStudent(payload);
      if (response?.data) {
        toast.success(`${isSuspend ? "Suspended" : "Activated"} successfully`);
        getStudentDetails();
      }
    } catch (error) {
      console.log("error", error);
      toast.error("Error! please try again");
    }
  };

  const onChange = (key) => {
    console.log(key);
  };

  return (
    <div className={styles.studentDetails}>
      <div className={styles.headerContainer}>
        <div className={styles.leftSection} onClick={() => navigate(-1)}>
          <LeftOutlined />
          <Typography className={styles.navTitle}>Students</Typography>
        </div>
        <div className={styles.rightActions}>
          <CustomButton
            title="Send Mail"
            style={{
              backgroundColor: "transparent",
              border: "none",
              color: "#39B54A",
              fontWeight: 500,
              fontSize: "14px",
            }}
            icon={<img src="/assets/images/messageIcon.svg" alt="mail" />}
          />
          <Popconfirm
            title={studentDetails?.is_active ? "Suspend" : "Active"}
            description={`Are you sure you want to ${
              studentDetails?.is_active ? "suspend" : "active"
            } this account?`}
            okText="Yes"
            cancelText="No"
            onConfirm={() => onSuspendAccount(studentDetails?.is_active)}
          >
            <span>
              {studentDetails?.is_active ? (
                <CustomButton
                  title="Suspend Account"
                  style={{
                    backgroundColor: "#F349111A",
                    border: "none",
                    color: "#F31111",
                    fontWeight: 500,
                    fontSize: "14px",
                  }}
                  icon={<img src="/assets/images/suspendIcon.svg" alt="mail" />}
                />
              ) : (
                <CustomButton
                  title="Active Account"
                  style={{
                    backgroundColor: "#eefdf9",
                    border: "none",
                    color: "#3bb44b",
                    fontWeight: 500,
                    fontSize: "14px",
                  }}
                  icon={<CheckCircleOutlined />}
                />
              )}
            </span>
          </Popconfirm>
        </div>
      </div>

      <div className={styles.profileCard}>
        <img
          src={
            studentDetails?.profile_picture ?? "assets/images/sample-user.png"
          }
          height={"60px"}
          width={"60px"}
          alt="profile_pic"
        />
        <div>
          <div className={styles.nameInfo}>
            <Typography className={styles.profileTitle}>
              {studentDetails?.name ?? "-"}
            </Typography>
            <StatusChip
              status={studentDetails?.is_active ? "active" : "inactive"}
            />
          </div>
          <div className={styles.nameInfo}>
            <Typography className={styles.lebelTtile}>Reg. No:</Typography>
            <Typography className={styles.labelValue}>
              {studentDetails?.reg_number ?? "-"}
            </Typography>
          </div>
          <div className={styles.nameInfo}>
            <Typography className={styles.lebelTtile}>Level:</Typography>
            <Typography className={styles.labelValue}>
              {studentDetails?.classroom?.level?.name ?? "-"}
            </Typography>
            <Typography className={styles.lebelTtile}>Classroom:</Typography>
            <Typography className={styles.labelValue}>
              {studentDetails?.classroom?.name ?? "-"}
            </Typography>
          </div>
        </div>
      </div>

      <Tabs
        defaultActiveKey="1"
        items={items}
        tabBarStyle={{ borderBottom: "none" }}
        onChange={onChange}
      />
    </div>
  );
};

export default StudentDetails;
